export default __webpack_public_path__ + "407a3481513d3c24e5ce1344a92b0d12.png";